import * as React from 'react';
import { PrismicPreview } from 'filou-web';
import { withRouter, Head } from 'react-static';
import Spezialist from './spezialist';
import IndexRoute from './index';
import fetchData from '../fetch';

const Preview = ({ history, location }: { history: any; location: any }) => {
  if (typeof window !== 'undefined') {
    window['prismic'] = {
      endpoint: 'https://${name}.prismic.io/api/v2'
    };
  }

  return (
    <PrismicPreview
      name="cooperativ"
      fetchData={fetchData}
      head={children => <Head>{children}</Head>}
      history={history}
      location={location}
      render={(data, id) => {
        if (id && data.spezialist[id]) {
          return <Spezialist item={data.spezialist[id]} />;
        } else if (data) {
          return (
            <IndexRoute
              spezialistList={data.spezialistList}
              partnerList={data.partnerList}
              template={data.template}
            />
          );
        }
        return null;
      }}
    />
  );
};

export default withRouter(Preview);
